import axios from 'axios';
import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import './editform.css';

function EditForm() {
  const {id} = useParams();
  const [category, setCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [name, setName] = useState('');
  const [isVeg, setIsVeg] = useState(true);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [mrpPrice, setMrpPrice] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [stock, setStock] = useState(0);
  const [description, setDescription] = useState('');
  const [quality, setQuality] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [photo, setPhoto] = useState(null);
  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL+`/api/Products/${id}`).then((res) => {
      setCategory(res.data.category);
      setBrand(res.data.brand);
      setName(res.data.name);
      setIsVeg(res.data.isVeg);
      setSellingPrice(res.data.price);
      setMrpPrice(res.data.mrp);
      setQuantity(res.data.quantity);
      setStock(res.data.stock);
      setDescription(res.data.description);
      setQuality(res.data.quality);
      setIsActive(res.data.isActive);
      setPhoto(res.data.img);
      console.log(res.data)
    }).catch((err) => {
      console.error(err);
    });
  }, [id]);
  const formData = new FormData();
    
  formData.append('Name', name);
  formData.append('MRP', mrpPrice);
  formData.append('Price', sellingPrice);
  formData.append('Quantity', quantity);
  formData.append('Description', description);
  formData.append('Quality', quality);
  formData.append('Brand', brand);
  formData.append('Category', category);
  formData.append('Stock',stock);
  formData.append('isActive',isActive);
  formData.append('isVeg',isVeg);
  formData.append('Img',photo);
  const handleFileChange = (event) => {
    setPhoto(event.target.files[0]);
  };
  const updatedata =  (e) => {
    e.preventDefault();
    try {
       axios.put(process.env.REACT_APP_API_URL+`/api/Products/${id}`,formData ).then((res) => {
        window.location.href = "/Products";
      }).catch((err) => {
        console.error(err);
      });
    }
    catch (error) {
      console.error(error);
    }
  }
  return (
    <>
   
          <form className="form1">
            <h1 className="text-3xl text-start font-bold mb-8">Edit Product</h1>
            <div className="line1">
              <div className="line11">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2 label1"
                for="category"
              >
                Category
              </label>
              <select
                className="shadow appearance-none select12 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                >
                <option>Select a category</option>
                <option>Fruits</option>
                <option>Vegetables</option>
                <option>Dairy</option>
                <option>Breads</option>
                <option>Meats</option>
                </select>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2 label1"
                for="brand"
              >
                Brand
              </label>
              <input
                className="shadow appearance-none border rounded input1 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type='text'
                for="brand"
                placeholder='Brand'
                onChange={(e) => setBrand(e.target.value)}
                value={brand}
                > 
                
                </input>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2 label1"
                for="name"
              >
                Name
              </label>
              <input
                className="shadow appearance-none border input1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={e => setName(e.target.value)}
                type="text"
                placeholder="Name"
                value={name}
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-800 text-sm font-bold mb-2 label1"
                for="Quality"
              >
                Quality
              </label>
              <input
                className="shadow appearance-none border rounded input1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) => setQuality(e.target.value)}
                type="text"
                placeholder="Quality"
                value={quality}
              />
            </div>
           
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2 label1"
                for="MRP"
              >
                MRP
              </label>
              <input
                className="shadow appearance-none border rounded  input1 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                
                type="text"
                placeholder="MRP"
                onChange={(e) => setMrpPrice(e.target.value)}
                value={mrpPrice}
              />
            </div>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-800 text-sm font-bold mb-2 label1"
                for="Quality"
              >
                Image
              </label>
              <img src={photo} alt="product img" className='img1' />
            </div>

            </div>
            <div className="line2">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2 label1"
                for="Price"
              >
                Price
              </label>
              <input
                className="shadow appearance-none border rounded input1 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                
                type="text"
                onChange={(e) => setSellingPrice(e.target.value)}
                placeholder="Price"
                value={sellingPrice}
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2 label1"
                for="Quantity"
              >
                Quantity
              </label>
              <input
                className="shadow appearance-none border rounded w-full input1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) => setQuantity(e.target.value)}
                type="text"
                placeholder="Quantity"
                value={quantity}
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-800 text-sm font-bold label1 mb-2"
                for="isVeg"
              >
                isVeg
              </label>
              <select
                className="shadow appearance-none select1 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="isVeg"
                onChange={(e) => setIsVeg(e.target.value)}
                value={isVeg}
              >
                <option>select isVeg or not</option>
                <option value={true}>Veg</option>
                <option value={false}>Non-Veg</option>
              </select>
            </div>
        
            </div>
            <div className="line3">
            <div className="mb-4">
              <label
                className="block text-gray-800 text-sm font-bold mb-2 label1"
                for="Stock"
              >
                Stock
              </label>
              {/* <select
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) => setStock(e.target.value)}
                type="number"
                placeholder="Stock"
                value={stock}
              >
                <option>select Stock</option>
                <option value={true}>In Stock</option>
                <option value={false}>Out of Stock</option>
              </select> */}
              <input
                className="shadow appearance-none border rounded input1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) => setStock(e.target.value)}
                type="number"
                placeholder="Stock"
                value={stock}/>
            </div>
           
           

            <div className="mb-4">
              <label
                className="block text-gray-800 text-sm font-bold mb-2 label1"
                for="Quality"
              >
                Image to change
              </label>
              <input
                className="shadow appearance-none border rounded input1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={handleFileChange}
                type="file"
                placeholder="Image"
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-800 text-sm font-bold mb-2 label1"
                for="isActive"
              >
                isActive
              </label>
              <select
                className="shadow appearance-none border rounded select1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) => setIsActive(e.target.value)}
                type="text"
                placeholder="isActive"
                value={isActive}
              >
                <option value={true}>Active</option>
                <option value={false}>Disabled</option>
              </select>
            </div>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2label1"
                for="Description"
              >
                Description
              </label>
              <textarea
                className="shadow appearance-none border rounded w-full textarea2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) => setDescription(e.target.value)}
                type="text"
                placeholder="Description"
                value={description}
              />
            </div>
            <div className="flex items-center justify-between">
              <button
                className="bg-blue-500 hover:bg-blue-700 button-edit text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={(e)=>{updatedata(e)}}
                type="button"
              >
                Edit
              </button>
            </div>
          </form>

      
    </>
  )
}

export default EditForm